import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { changeAvatar, logout } from "../../actions/auth";
import logoIcon from "../../assets/images/logo.png";
import userIcon from "../../assets/images/icon-user.png";
import { Dropdown, Menu, Button  } from 'antd'
import { SwapOutlined, CheckOutlined } from '@ant-design/icons'
import compose from "recompose/compose";
import store from "../../store";
import { getUserInfo } from "../../actions/subscribe";
import { 
  getMenuList,
  loadMenu
} from '../../actions/auth'
import { borderRadius, display, fontSize } from "@mui/system";

const styles = (theme) => ({
  topContainer: {
    width: '100%',
    height: '54px',
    padding: '0 20px 0 20px',
    position: 'sticky',
    top: '0',
    background: 'rgb(9, 2, 83)',
    zIndex: '100',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& img': {
      height: '40px',
      maxWidth: '160px',
      objectFit: 'contain'
    }
  },
  menuListBox: {
    flex: '1',
    width: '80%',
    marginLeft: '100px',
    display: 'flex',
    alignItems: 'center',
  },
  menu: {
    position: 'relative',
    width: '160px',
    height: '54px',
    lineHeight: '54px',
    fontSize: '16px',
    marginLeft: '30px',
    textAlign: 'center',
    cursor: 'pointer',
    '&.active, &:hover': {
      borderBottom: '3px solid rgb(253 200 65)',
      color: 'rgb(253 200 65)'
    },
    '&:hover .sub-box': {
      display: 'block',
    }
  },
  subMenuBox: {
    display: 'none',
    position: 'absolute',
    left: '0',
    top: '54px',
    width: '360px',
    padding: '20px',
    background: '#fff',
    boxShadow: '0 3px 8px rgba(0,0,0,.2)',
    color: 'rgb(9, 2, 83)'
  },
  subMenuTitle: {
    width: '100%',
    height: '24px',
    marginBottom: '10px',
    paddingBottom: '10px',
    borderBottom: '1px solid #eaeaea',
    fontSize: '14px',
    lineHeight: '14px',
    fontWeight: '600',
    textAlign: 'left',
    color: '#5A5A5A',
  },
  subMenuList: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  subMenu: {
    width: '50%',
    height: '32px',
    lineHeight: '32px',
    fontSize: '14px',
    color: '#5A5A5A',
    textAlign: 'left',
    '&:hover': {
      color: '#40a9ff'
    },
    '&.active': {
      color: '#40a9ff'
    }
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '& img': {
      height: '32px'
    }
  },
  appName: {
    cursor: 'pointer',
    marginRight: '20px',
  },
  menuItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  avatar: {
    borderRadius: '50%',
    width: '32px',
    height: '32px'
  },
  linkBtn: {
    marginLeft: "15px",
    color: '#fff',
    '&:hover': {
      color: '#40a9ff'
    } 
  }
})


export class Top extends Component { 
  static propTypes = {
    auth: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
    loadMenu: PropTypes.func.isRequired,
  };

  state = {
    menuIndex: 0,
    subMenuIndex: -1,
    applicationName: "",
    topMenuList: [],
    logoUrl: "",
    companyList: [],
  }


  componentDidMount() {
    let application_id = localStorage.getItem('applicationId')
    let list = localStorage.getItem('applicationList')
    let applicationName = localStorage.getItem('applicationName')
    if (list) {
      this.setState({
        companyList: JSON.parse(list),
        applicationName
      })
    } else {
      this.setState({
        applicationName
      })
    }

    let pathname = window.location.pathname
    if(pathname != '/singleLogin') {
      this.initCompany(application_id)
      this.initAvatar()
    }
  }

  initAvatar = () => {
    getUserInfo({ username: store.getState().auth.username }).then((res) => {
      if (res.results && res.results.length > 0) {
        let userData = res.results.filter((v) => {
          return v.username == store.getState().auth.username;
        })[0];
        if (userData) {
          
          // 修改全局头像
          this.props.changeAvatar(userData.avatar)
        }
      }
    });
  }

  initCompany = (id) => {
    getMenuList({
      application_id: id
    }).then(res => {
      let list = (res.result || []).sort((a, b) => {
        return a.menu1_order_index - b.menu1_order_index
      }).map(v => {
        return {
          title: v.l1_menu_name,
          children: v.menu2_list.map(val => {
            return {
              title: val.l2_menu_name,
              path: val.menu_url,
              query_url: val.query_url,
            }
          })
        }
      })

      let urlList = []
      list.forEach(v => {
        v.children.forEach(val => {
          urlList.push(val.path)
        })
      })
      localStorage.setItem('userUrls', urlList.join())

      let index_url = localStorage.getItem('indexUrl')
      let logoUrl = localStorage.getItem('logoUrl')
      
      let allMenuList = [{
        title: '首页',
        path: index_url || '/index'
      }].concat(list)

      this.setState({
        topMenuList: allMenuList,
        logoUrl: logoUrl
      })
      this.props.loadMenu(allMenuList)

      let pathname = window.location.pathname
      // 初始化菜单高亮
      let menuIndex = 0
      let subMenuIndex = 0
      allMenuList.forEach((v, i) => {
        if (v.children && v.children.length > 0) {
          v.children.forEach((val, index) => {
            if (val.path == pathname) {
              subMenuIndex = index
              menuIndex = i
            }
          })
        }
      })
      this.setState({
        menuIndex: menuIndex,
        subMenuIndex: subMenuIndex,
      })
    })
  }

  changeApplication = (data) => {
    localStorage.setItem("applicationId", data.application_id);
    localStorage.setItem("indexUrl", data.index_url);
    localStorage.setItem("logoUrl", data.application_logo_url);
    localStorage.setItem('applicationName', data.application_name)
    this.setState({
      applicationName: data.application_name
    })
        
    let pathname = this.props.location.pathname;
    if (pathname == '/index') {
      window.location.reload()
    } else {
      this.props.history.push('/index')
      this.initCompany(data.application_id)
    }
  }
  
  render() { 
    const items = [
      { label: '用户信息', key: 'item-1' }, 
      { label: '退出登录', key: 'item-2' },
    ];

    const applicationItem = (
      <Menu>
        {
          this.state.companyList.map((v, i) => (
            <Menu.Item className={this.props.classes.menuItem} key={i} onClick={() => this.changeApplication(v)}>
              <span style={{marginRight: '10px'}}>
                {v.application_name}
              </span>
              <span>
                {
                  this.state.applicationName == v.application_name &&
                  <CheckOutlined style={{fontSize: '12px'}}/>
                }
              </span>
            </Menu.Item>
          ))
        }
      </Menu>
    )


    const subMenuClick = (data, i, index) => {
      let path = data.path
      let link = data.query_url
      if (path) {
        this.props.history.push(path)
      } else if (link) { 
        toLink(link)
      }
      this.setState({
        menuIndex: i,
        subMenuIndex: index
      })
    }

    const menuClick = (data, i) => {
      this.setState({
        menuIndex: i
      })
      if (data.path) {
        this.props.history.push(data.path)
      } else if (data.children && data.children.length > 0) {
        let path = data.children[0].path
        let link = data.children[0].query_url
        this.setState({
          subMenuIndex: 0
        })
        if (path) {
          this.props.history.push(path)
        } else if (link) {
          toLink(link)
        }
      }
    }

    const toLink = (link) => {
      let a = document.createElement('a')
      a.href = link
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }

    const toOldPlatform = () => {
      let token = localStorage.access
      let baseURL = ''
      let href = window.location.href
      if (href.indexOf('test.anwin.co') > -1) {
        baseURL = 'https://testmedtronic.anwin.co'
      } else {
        baseURL = 'https://medtronic.anwin.co'
      }
      let url = `${baseURL}/singleLogin?token=${token}`
      window.location.href = url
    }
    
    const classes = this.props.classes;
    
    const { avatar } = this.props
    return (
      <div className={classes.topContainer}>
        <img src={this.state.logoUrl || logoIcon} alt="" />
        
        <div className={classes.menuListBox}>
          {
            this.state.topMenuList.map((v, i) => (
              <div key={i} className={[classes.menu, this.state.menuIndex === i ? 'active' : ''].join(' ')}>
                <span onClick={ () => menuClick(v, i) }>{v.title}</span>
                {
                  v.children && 
                  <div className={[classes.subMenuBox, 'sub-box'].join(' ')}>
                    <div className={classes.subMenuTitle}>{v.title}</div>
                      <div className={classes.subMenuList}>
                        {
                          v.children.map((val, index) => (
                            <div key={`sub-menu-${i}-${index}`} className={[classes.subMenu, this.state.subMenuIndex === index && this.state.menuIndex === i ? 'active' : ''].join(' ')}  onClick={() => subMenuClick(val, i, index)}>{ val.title}</div>
                          ))
                        }
                      </div>
                  </div>
                }
              </div>
            ))
          }
        </div>

        <div className={classes.user}>
          {
            this.state.companyList.length > 1 &&
            <Dropdown overlay={applicationItem} >
              <div className={classes.appName}><SwapOutlined style={{fontSize: '24px'}}/></div>
            </Dropdown>
          }
          {
            avatar ? 
            <img src={avatar} className={classes.avatar}/> :
            <img src={ userIcon } alt="" />
          }
          {/* {
            this.props.company_name == 'Medtronic' &&
            <Button type="text" className={classes.linkBtn} onClick={toOldPlatform}>前往旧版</Button>
          } */}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    avatar: state.auth.avatar,
    company_name: state.auth.company_name,
  }
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { logout, loadMenu, changeAvatar })
)(withRouter(Top));